import { uniqueId } from 'lodash'
import type { LayoutDoneOptions } from '@wix/thunderbolt-symbols'
import type { LayoutCallbacksHandlers } from '../types'

export const initLayoutNotifier = <LayoutCallbackType extends Function>() => {
	const publicCallbacks: LayoutCallbacksHandlers<LayoutCallbackType> = new Map()
	const internalCallbacks: LayoutCallbacksHandlers<LayoutCallbackType> = new Map()

	return {
		subscribe(callback: LayoutCallbackType, options: LayoutDoneOptions, isPublicCallback: boolean): string {
			const callbackId = uniqueId()
			if (isPublicCallback) {
				publicCallbacks.set(callbackId, { callback, options })
			} else {
				internalCallbacks.set(callbackId, { callback, options })
			}
			return callbackId
		},
		unsubscribe(callbackId: string) {
			publicCallbacks.delete(callbackId)
			internalCallbacks.delete(callbackId)
		},
		notify(...args: any) {
			internalCallbacks.forEach(({ callback, options }, callbackId) => {
				callback(...args)
				if (options && options.once) {
					internalCallbacks.delete(callbackId)
				}
			})
			publicCallbacks.forEach(({ callback, options }, callbackId) => {
				callback(...args)
				if (options && options.once) {
					internalCallbacks.delete(callbackId)
				}
			})
		},
	}
}
